import StateType from './state.type';

export default {
  loading: false,
  orders: [],
  total: 0,
} as StateType;
